<template>
  <div class="blocked">
    <div class="blocked__top">
      <button class="blocked__back" @click="$emit('back')"></button>
      <button class="blocked__rules" @click="$emit('rules')">规则&好礼</button>
    </div>
    <div class="blocked__hero"></div>
    <div class="blocked__panel">
      <div class="blocked__mark">!</div>
      <h2>暂无法参与本次活动</h2>
      <p>你的账号因涉嫌违反活动规则，暂无法进入世界杯竞猜。如有疑问，请联系客服申诉。</p>
      <button class="blocked__primary" @click="$emit('customer-service')">联系客服</button>
      <button class="blocked__secondary" @click="$emit('back')">返回</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorldCupQuizBlocked'
}
</script>

<style scoped lang="scss">
.blocked {
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 480px;
  min-height: 100vh;
  box-sizing: border-box;
  margin: 0 auto;
  overflow: hidden;
  background: #145720;
}

.blocked__top {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: calc(var(--quiz-safe-top, 0px) + var(--quiz-nav-height, 48px));
  padding: var(--quiz-safe-top, 0px) 18px 0;
  box-sizing: border-box;
  color: #fff;
}

.blocked__back,
.blocked__rules {
  border: 0;
  background: transparent;
}

.blocked__back {
  position: relative;
  width: 32px;
  height: 32px;
}

.blocked__back:before {
  content: "";
  position: absolute;
  top: 9px;
  left: 10px;
  width: 10px;
  height: 10px;
  border-left: 2px solid rgba(255, 255, 255, .92);
  border-bottom: 2px solid rgba(255, 255, 255, .92);
  transform: rotate(45deg);
}

.blocked__rules {
  height: 32px;
  padding: 0;
  color: rgba(255, 255, 255, .96);
  font-size: 14px;
  font-weight: 700;
}

.blocked__hero {
  min-height: 439px;
  background:
    linear-gradient(180deg, rgba(20, 87, 32, 0) 0%, rgba(20, 87, 32, 0) 88%, #145720 100%),
    url('~@/assets/image/worldcupQuiz/hero.png') center top/100% auto no-repeat;
}

.blocked__panel {
  position: relative;
  z-index: 1;
  overflow: hidden;
  flex: 1;
  min-height: calc(100vh - 400px);
  margin-top: -70px;
  padding: 115px 22px 24px;
  border-radius: 22px 22px 0 0;
  box-sizing: border-box;
  text-align: center;
  background:
    radial-gradient(ellipse at 50% 145px, rgba(255, 255, 255, .12), transparent 36%),
    linear-gradient(180deg, transparent 0, transparent 145px, rgba(20, 87, 32, .96) 145px, #145720 100%);
}

.blocked__panel:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 145px;
  pointer-events: none;
  box-sizing: border-box;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(255, 255, 255, .16) 0%, rgba(255, 255, 255, 0) 100%);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.blocked__panel > * {
  position: relative;
  z-index: 1;
}

.blocked__mark {
  display: none;
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 50%;
  color: #fff;
  border: 2px solid rgba(255, 219, 86, .46);
  background: rgba(198, 58, 45, .82);
  line-height: 64px;
  font-size: 30px;
  font-weight: 800;
}

h2 {
  margin: 0;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
}

p {
  max-width: 280px;
  margin: 14px auto 24px;
  color: rgba(255, 255, 255, .72);
  font-size: 14px;
  line-height: 20px;
}

.blocked__panel button {
  display: block;
  width: 240px;
  height: 48px;
  margin-left: auto;
  margin-right: auto;
  border: 0;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
}

.blocked__primary {
  color: #145720;
  background: linear-gradient(180deg, #ffe56b, #ffb94a);
}

.blocked__panel .blocked__secondary {
  margin-top: 16px;
  border: 2px solid #FFCB33;
  color: #ffdb56;
  background: transparent;
}
</style>
